/**
 * Created by calhosh on 11/20/2024
 */
import React from 'react';
import {numberFormattedText} from '@ey/utils';
import styled from 'styled-components';

export default function CharCount(props) {
	const {
		charactersLabel,
		charCount = 0,
		characterCountPrefix,
		maxCharCount,
		numberFormat,
		ofLabel,
		showMaxCharacterCount
	} = props;
	return (
		<React.Fragment>
			{showMaxCharacterCount === true ? (
				<StyledCharCount>
					{`${numberFormattedText(numberFormat, charCount.toString())} ${ofLabel} ${numberFormattedText(
						numberFormat,
						maxCharCount.toString()
					)} ${charactersLabel}`}
				</StyledCharCount>
			) : (
				<StyledCharCount>{`${characterCountPrefix} ${charCount || ''}`}</StyledCharCount>
			)}
		</React.Fragment>
	);
}

const StyledCharCount = styled.section`
	font-size: var(--px-12);
	font-weight: 300;
	float: right;
	margin-right: var(--px-8);
`;
